import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="#FFD6B0" {...props}>
      <title>{props.title || 'Time'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path d="M24 0C37.2514 0 48 10.7486 48 24C48 37.2514 37.2514 48 24 48C10.7486 48 0 37.2514 0 24C0 10.7486 10.7486 0 24 0Z" />
        <path
          d="M24.2369 33.0591C28.9727 33.0591 32.8118 29.2202 32.8118 24.4846C32.8118 19.7491 28.9727 15.9102 24.2369 15.9102C19.5012 15.9102 15.6621 19.7491 15.6621 24.4846C15.6621 29.2202 19.5012 33.0591 24.2369 33.0591Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.375 18.4844L24.6187 24.484L26.7036 27.9163"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1631 24.4844H9.75"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.7236 24.4844H36.3105"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2344 12.4125V10"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2344 38.9692V36.5566"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.2734 14.0292L31.48 11.9395"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9922 37.0292L18.1987 34.9395"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.6934 18.4485L36.7831 17.2422"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6895 31.7278L13.7792 30.5215"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1987 14.0292L16.9922 11.9395"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.48 37.0292L30.2734 34.9395"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7792 18.4485L11.6895 17.2422"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.7831 31.7278L34.6934 30.5215"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
